import { defaultHttpClient } from '../../httpClient';
import type { GetPromotionsComponentsResponse } from './types';

export const getPromotionsComponents = (
  goodsSno: number,
  screen: 'GOODS_DETAIL' | 'GOODS_OPTION_MODAL',
) => {
  return defaultHttpClient
    .request<GetPromotionsComponentsResponse>({
      method: 'GET',
      url: `/api/v2/promotions/components`,
      params: { goods_sno: goodsSno, screen },
    })
    .then(result => result.data);
};
